import IFrame from '@/components/iframe';

function PeachBlossom({ src }) {
  return <IFrame src={src} iframename="taohuadao" />;
}

export default PeachBlossom;
